import { Component } from '@angular/core';
import { LiveClassCountdownTimerService } from '../../../../../../home/live-class-section/services/live-class-countdown-timer.service';
import { OeAppService } from '../../../../../../shared/oe-app.service';
import { LiveClassWithCountdownTimerPlusMinutesComponent } from '../../../../live-class-with-countdown-timer/live-class-with-countdown-timer-plus-minutes.component';

@Component({
  selector: 'lp2-group-class-state-can-sign-up',
  template: `
    <lp2-live-class-state-view-title theme="light" [labelKey]="labelKeyForGroup">
      <div class="ml-auto mr-auto mt-2 pt-0 mt-sm-0">
        <lp2-live-class-state-view-timer
          theme="light"
          [minutes]="minutesForGroup"
          [seconds]="seconds"
          size="small"
        ></lp2-live-class-state-view-timer>
      </div>
    </lp2-live-class-state-view-title>
    <div class="mt-3 text-center">{{ 'oeapp.studybundle.gc.signupEndsInstruction' | translate }}</div>
  `,
})
export class GroupClassStateCanSignUpComponent extends LiveClassWithCountdownTimerPlusMinutesComponent {
  constructor(liveClassCountdownTimerService: LiveClassCountdownTimerService, private oeAppService: OeAppService) {
    super(liveClassCountdownTimerService);
    this.signUpConfigValue = this.oeAppService.getData('liveClassStudentSignUpEnd');
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/group-class/group-class-tile/group-class-tile-states/states/group-class-state-can-sign-up.component.ts